export const nonAlphanumericRegex = /[^a-zA-Z0-9]/g;

export const nonDashAlphanumericRegex = /[^a-zA-Z0-9-]/g;

export const nonDashAlphanumericPlusRegex = /[^a-zA-Z0-9-+]/g;

export const alphaNumericDashUnderscoreRegex = /^[a-zA-Z0-9_-]*$/;

export const alphaNumericDashUnderscoreWhitespaceRegex = /^[a-zA-Z0-9_-\s]*$/;

export const appVersionRegex = /^\d+\.\d+\.\d+$/;

export const dateFullYearRegex =
  /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(\d{4})$/;

export const dateShortYearRegex =
  /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(\d{2})$/;

export const isoDateRegex =
  /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z\b/;
